import Vue from 'vue'
import Vuex from 'vuex'
import reflectList from './modules/reflect/store'
import setting from './modules/setting/store'
import hqPordIndex from './modules/hqpord_index/store'
import hqPordInto from './modules/hqpord_into/store'
import cardBind from './modules/card_bind/store'
import pages from './modules/pages/store'
import pay from './modules/recharge/store'
import ticket from './modules/ticket/store'
import payTest from './modules/pay_test/store'
import redPacket from './modules/packet/store'
import getUserCashMonth from './modules/hqpord_detail/store'
const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)
Vue.config.debug = true

export default new Vuex.Store({
  modules: {
    reflectList,
    setting,
    hqPordIndex,
    hqPordInto,
    cardBind,
    pages,
    pay,
    ticket,
    payTest,
    redPacket,
    getUserCashMonth
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/vuex/store.js